import { useState, useEffect, useCallback } from 'react';
import { teacherAPI } from '../utils/api';
import { logClientError } from '../utils/safeLog';

export function useTeacherPresets(isTeacher) {
  const [presets, setPresets] = useState([]);
  const [selectedPresetId, setSelectedPresetId] = useState('');
  const [isPresetPanelOpen, setIsPresetPanelOpen] = useState(false);

  const loadPresets = useCallback(async () => {
    if (!isTeacher) return;
    try {
      const response = await teacherAPI.getPresets();
      setPresets(response.data || []);
    } catch (err) {
      logClientError('Failed to load teacher presets:', err);
    }
  }, [isTeacher]);

  useEffect(() => {
    loadPresets();
  }, [loadPresets]);

  const selectedPreset = presets.find(p => String(p.id) === String(selectedPresetId)) || null;

  return {
    presets,
    selectedPresetId,
    setSelectedPresetId,
    selectedPreset,
    loadPresets,
    isPresetPanelOpen,
    setIsPresetPanelOpen,
  };
}
